module.exports = __webpack_public_path__ + "img/LK.3ecf88e1.png";